import { RotateCcw } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../logo.svg';

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="bg-white/70 backdrop-blur-sm border-b border-stone-300/70 px-4 md:px-6 py-3 flex items-center justify-between sticky top-0 z-30 no-print">
      <div className="flex items-center gap-3">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity no-underline" aria-label="Resume Builder — back to home">
          <Logo className="w-7 h-7" aria-hidden="true" />
          <h1 className="tool-display text-xl text-stone-900 italic leading-none font-normal m-0">Resume Builder</h1>
        </Link>
        <span className="hidden sm:inline text-stone-300">|</span>
        <span className="hidden sm:inline tool-body text-xs uppercase tracking-[0.2em] text-stone-500">Editor</span>
      </div>
      <nav aria-label="Editor actions">
        <button
          onClick={() => navigate('/')}
          className="tool-body text-xs text-stone-600 hover:text-stone-900 flex items-center gap-1.5 px-3 py-1.5 rounded hover:bg-stone-100 transition-colors"
        >
          <RotateCcw className="w-3.5 h-3.5" /> Start over
        </button>
      </nav>
    </header>
  );
}
